import { render, staticRenderFns } from "./RecordList.vue?vue&type=template&id=f72d2eca&scoped=true"
import script from "./RecordList.vue?vue&type=script&lang=js"
export * from "./RecordList.vue?vue&type=script&lang=js"
import style0 from "./RecordList.vue?vue&type=style&index=0&id=f72d2eca&prod&scoped=true&lang=css"
import style1 from "./RecordList.vue?vue&type=style&index=1&id=f72d2eca&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72d2eca",
  null
  
)

export default component.exports